import request from "@/utils/httpRequest.js"

 export function fetchByCode(code) {
  return request({
    url: 'rich-text/code',
    method: 'get',
    params: {
      code: code
    }
  })
}